var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpingInModeling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF2FA;}\n\t.st1{fill:none;stroke:#1930AB;stroke-width:15;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#1930AB;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.4,41.3c0,0,202.7,139.8,169.6,302.9c0,0-34.4,170.3-313.4,137.5c-52.2-6.1-100.1-30.9-131.4-70.3 c-15.2-19.4-26.7-41.4-33.6-65.1C-1,301.4,5,253.2,27.7,211.5C77.3,120.4,193.5-52.7,321.4,41.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 247.4,
    cy: 114.9,
    r: 20.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 247.1,
    y1: 138.2,
    x2: 247.1,
    y2: 183.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 374,
    cy: 366.3,
    r: 20.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 357.8,
    y1: 349.6,
    x2: 325.5,
    y2: 317.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 121,
    cy: 366.3,
    r: 20.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 137.2,
    y1: 349.6,
    x2: 169.5,
    y2: 317.3
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "207.6,161.7 129.3,192.6 129.3,309.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "287.3,161.7 365.6,192.6 365.6,309.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "134.3,195.5 245.6,239.4 357.9,195  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "179.3,360.6 245.6,386.5 317.9,362.1  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 246.4,
    y1: 243,
    x2: 246.4,
    y2: 382.9
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpingInModeling);
export default __webpack_public_path__ + "static/media/helping_in_modeling.7d3ec550893987ee23f851034beeda42.svg";
export { ForwardRef as ReactComponent };